// Mutation hook - usuniecie kontaktu transakcji
// DELETE /api/ui/sales-crm/deals/{id}/contacts/{contactId}

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

interface IDeleteDealContactResponse {
  data?: { id?: number };
  message?: string;
  status?: string;
}

interface IDeleteDealContactVariables {
  dealId: number;
  contactId: number;
}

const deleteDealContact = ({
  dealId,
  contactId,
}: IDeleteDealContactVariables): Promise<IDeleteDealContactResponse> =>
  axios.delete(`/sales-crm/deals/${dealId}/contacts/${contactId}`);

export const useDeleteDealContact = (
  options?: UseMutationOptions<IDeleteDealContactResponse, IError, IDeleteDealContactVariables>,
) => {
  const queryClient = useQueryClient();
  return useMutation<IDeleteDealContactResponse, IError, IDeleteDealContactVariables>(
    deleteDealContact,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(['sales-crm-deal-contacts', variables.dealId]);
        await queryClient.refetchQueries(['sales-crm-deal-contacts', variables.dealId]);
        options?.onSuccess?.(data, variables, context);
      },
    },
  );
};
